import teaserControl from "./teaserControl";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.category')) {
        const category = document.querySelector('h1').textContent.split(' ')[0].toLowerCase();
        teaserControl({fixedCategory: category, category: false});
    }
})